import React from 'react';
import { withSessionSsr, getPublicToken } from "../../lib/sessionMiddleware";
import { getCanonicalPath } from "../../lib/canonical";
import {
  Navbar,
  Wrapper,
  TituloSeccion,
  SubtituloSeccion,
  Seccion,
  Footer,
  HeadTags,
  BtnFlotanteWhatsapp,
  Container,
}from '../../components';
import MarkdownView from 'react-showdown';


const NosotrosPage = (props)=>{

  const contenido = props.pageProps.contenido;

  return(<>

    <HeadTags  
      title="Nosotros" 
      description=""
      path={props.pageProps.pathname}
    />

    <Navbar/>

    <Seccion padding="40px 20px" paddingMobile="20px">
      <Wrapper>             
        <TituloSeccion align="center">Nosotros</TituloSeccion>
        <br/>
        <SubtituloSeccion align="center">¡Queremos que tu festejo sea el mejor!</SubtituloSeccion>
        <br/><br/>
        <Container width="1000px">
          {contenido[0]?.attributes?.contenido ?
            <MarkdownView
              markdown={contenido[0]?.attributes?.contenido}
              options={{ tables: true, emoji: true }}
              style={{lineHeight: "1.816rem", listStylePosition: "inside"}}
            /> 
            :
            <p>Sin contenido cargado con el nombre &quot;nosotros&quot;.</p>
          }
        </Container>

      </Wrapper>
    </Seccion>

    <br/><br/><br/>
        
    <Footer/>
 
    <BtnFlotanteWhatsapp/>
  </>);
};

export default NosotrosPage;

export const getServerSideProps = withSessionSsr(
  async function getServerSideProps(ctx) {
  
    const { req } = ctx;
        
    const publicToken = await getPublicToken(req);
    const fetchContent = async()=>{
      let body = {
        nombre: "nosotros"
      };
      try{
        const result = await fetch(`${process.env.NEXT_PUBLIC_URL_FRONTEND}/api/contenidos/get-all`, {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json',
            'x-spiral-secret': process.env.SPIRAL_SECRET
          },
          body: JSON.stringify(body)
        });
        let data = await result.json();
        // console.log("contenido", data.data)
        return (data?.data || []);
      }catch(err){
        console.log("e", err);
        return [];
      }     
    };

    let contenido = await fetchContent();

    return {
      props: {
        pathname: getCanonicalPath(req),
        contenido: contenido,
      },
    };    
  
  },
);